/* FAR - «La tua moto» (21/10/2026). Codice comune a tutte le pagine, caricato da snippets/far-moto.liquid subito dopo la barra
   «Ricerca per moto» come script normale (non defer, non async): parte nello stesso momento in cui partiva quando era scritto dentro lo
   snippet, così al telefono la scheda nera è già al suo posto quando la pagina compare. I dati (testi nelle 5 lingue, foto dei menu,
   indirizzi) restano nello snippet, negli attributi data-* di #FarMoto.
   1) RIQUADRO «LA TUA MOTO»: computer = riquadro al posto dell'etichetta della barra (foto o simbolo, nome in bianco, «Cambia», X);
      telefono home = scheda nera di far-vehicle-finder-pro.js decorata; telefono altre pagine = scheda creata qui mentre la pagina si
      carica (non nella pagina risultati). Foto dal feed delle pagine marca (/collections/<marca>?view=far-modelli), un tentativo per
      pagina; se la foto è di un'altra moto o manca: simbolo. La moto si ignora e si toglie dopo 90 giorni (come «Prima dell'acquisto»).
   2) LA X: toglie moto, filetto, foto e prodotti salvati, svuota le tendine, manda l'evento far:moto-change (far-temi,
      far-collection-stili, pulsante del video della home), mostra «✓ Moto tolta: scegline un'altra» per 4 secondi (computer: nel
      riquadro; telefono: nel sottotitolo della scheda nera) e apre la barra sulla marca; scorre fino alla barra solo se non si vede.
   3) MENU: foto piccole nelle tendine e prima riga «Mostra solo quelli per la tua moto» / «Scegli la tua moto».
   4) AIUTI: window.FARMoto = { leggi, etichetta, urlRisultati, apri, togli, dedicati, dedicatiPer, tipi, money, root, T, foto, piastrella }.
   21/10/2026 notte (D-bis): passando il mouse su foto e nome del riquadro compare il nome intero della moto (aria-label = «La tua moto:
   nome – Vedi i prodotti per la tua moto»); dopo la X nella scheda prodotto (pagina ricaricata) il messaggio si vede anche su computer.
   21/10/2026 sera (punto I, «cruscotto definitivo»): su computer il cruscotto non sta più su una riga sua sopra le tendine ma DENTRO la
   riga delle tendine, al posto di «Ricerca per moto», alto e arrotondato come le tendine; «Cambia» è un pulsante-icona (⇄). La barra con
   la moto ha le stesse righe e la stessa altezza della barra senza moto: una copia invisibile della riga senza moto («sonda») dice come
   starebbe la barra in quella lingua e a quella larghezza, e disponi() sceglie la disposizione con le stesse righe (vedi sotto).
   Diario: FAR-programma/tema/moto-premium-2026-10-21/LEGGIMI.md */
(function () {
  var cfg = document.getElementById('FarMoto');
  if (!cfg || window.FARMoto) return;
  var T = {}; try { T = JSON.parse(cfg.getAttribute('data-t') || '{}'); } catch (e) {}
  var FOTO = {}; try { FOTO = JSON.parse(cfg.getAttribute('data-foto') || '{}'); } catch (e) {}
  var TIPI = {}; try { TIPI = JSON.parse(cfg.getAttribute('data-tipi') || '{}'); } catch (e) {}
  var ROOT = (cfg.getAttribute('data-root') || '/').replace(/\/$/, '');
  var RES = cfg.getAttribute('data-results') || '/pages/compatibilita-risultati';
  var MARCA = cfg.getAttribute('data-marca') || '/pages/brand';
  var SEZ = 'shopify-section-ricerca-veicolo-far', BRAND = 'FarVfBrand-ricerca-veicolo-far', TOGGLE = 'FarVfToggle-ricerca-veicolo-far';
  var TPL = cfg.getAttribute('data-tpl') || '';
  var SCADENZA = 90 * 864e5; /* 90 giorni, come snippets/far-moto-monta.liquid */
  /* marca della tendina (senza maiuscole e segni) → collezioni marca con il feed ?view=far-modelli (verificate il 21/10/2026) */
  var COLL = { aprilia: ['aprilia'], benelli: ['benelli'], bimota: ['bimota'], bmw: ['bmw'], ducati: ['ducati'], harleydavidson: ['harley-davidson'], honda: ['honda'], kymco: ['kymco'], ktm: ['ktm'], malaguti: ['malaguti'], motoguzzi: ['moto-guzzi'], motomorini: ['motomorini'], kawasaki: ['kawasaki'], mvagusta: ['mv-agusta'], cagiva: ['mv-agusta'], peugeot: ['peugeot'], piaggio: ['piaggio'], vespa: ['vespa', 'piaggio'], triumph: ['triumph'], suzuki: ['suzuki'], yamaha: ['yamaha'], cfmoto: ['cf-moto'], hyosung: ['hyosung'], royalenfield: ['royal-enfield'], voge: ['voge'], sym: ['sym'] };
  var ICO_X = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 6l12 12M18 6L6 18"/></svg>';
  var ICO_CAMBIA = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M4 8h14l-3.5-3.5M20 16H6l3.5 3.5"/></svg>';
  var ICO_OK = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var SYM = '<span class="far-garage__sym" aria-hidden="true"><svg viewBox="0 0 120 72" focusable="false"><circle cx="25" cy="50" r="15"/><circle cx="95" cy="50" r="15"/><path d="M25 50 L44 31 H66 L76 38"/><path d="M95 50 L83 20 L91 16"/><path d="M36 30 Q50 17 70 25 L76 31"/><path d="M44 31 L56 47 H76 L83 31"/></svg></span>';

  function squash(s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
  function rawMoto() { try { return localStorage.getItem('far:moto'); } catch (e) { return null; } }
  /* moto più vecchia di 90 giorni: non si mostra più e si toglie dalla memoria (con il filetto e la foto, che sono della stessa moto) */
  function dimentica() { try { localStorage.removeItem('far:moto'); localStorage.removeItem('far:attacco'); localStorage.removeItem('far:moto-foto'); } catch (e) {} }
  function leggi() {
    var m = null; try { m = JSON.parse(rawMoto() || 'null'); } catch (e) {}
    if (m && m.t && Date.now() - m.t > SCADENZA) { dimentica(); return null; }
    return (m && m.marca && m.modello) ? m : null;
  }
  function etichetta(m) { return m.etichetta || (m.marca + ' · ' + m.modello); }
  function urlRisultati(m) {
    return RES + '?marca=' + encodeURIComponent(m.marca) + '&modello=' + encodeURIComponent(m.modello) + (m.versione ? '&versione=' + encodeURIComponent(m.versione) : '') + (m.anno ? '&anno=' + encodeURIComponent(m.anno) : '') + '&da=viaggio';
  }
  function sez() { return document.getElementById(SEZ); }
  function suRisultati() { return location.pathname.indexOf('/pages/compatibilita-risultati') > -1; }
  /* la barra si vede già (in alto, non coperta dall'intestazione fissa): allora niente scorrimento */
  function inVista(s) {
    var r = s.getBoundingClientRect(), h = window.innerHeight || document.documentElement.clientHeight || 0;
    if (!r.height || r.top < 0 || r.top > h * 0.6) return false;
    if (!document.elementFromPoint) return true;
    var x = Math.round(Math.min(Math.max(r.left + Math.min(r.width / 2, 160), 1), (window.innerWidth || document.documentElement.clientWidth || 2) - 1));
    var el = document.elementFromPoint(x, Math.round(r.top + 6));
    return !el || s.contains(el);
  }
  function apri() {
    var s = sez(); if (!s) { location.href = MARCA; return; }
    if (!inVista(s)) {
      var y = s.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }
    var mt = s.querySelector('.far-vf-mobile-toggle');
    if (mt && getComputedStyle(mt).display !== 'none' && !s.classList.contains('far-vf-is-open')) mt.click();
    var t = document.getElementById(TOGGLE);
    if (t && getComputedStyle(t).display !== 'none' && t.getAttribute('aria-expanded') !== 'true') t.click();
    s.classList.add('far-vf--lampo');
    setTimeout(function () { s.classList.remove('far-vf--lampo'); }, 2400);
    var sel = document.getElementById(BRAND);
    if (sel) setTimeout(function () { try { sel.focus({ preventScroll: true }); } catch (x) {} }, 800);
    aria();
  }
  document.addEventListener('click', function (e) {
    var x = e.target.closest('.far-garage__x');
    if (x) { e.preventDefault(); togliMoto(); return; }
    var o = e.target.closest('.far-mcard__open');
    if (o) {
      e.preventDefault();
      var s = sez(), t = document.getElementById(TOGGLE);
      if (s && t && s.classList.contains('far-vf-is-open')) { t.click(); aria(); } else apri();
      return;
    }
    var b = e.target.closest('[data-far-apri-moto]');
    if (!b) return;
    e.preventDefault();
    apri();
  });
  window.farApriMotoPronto = true;
  function aria() { setTimeout(function () { var s = sez(), o = s && s.querySelector('.far-mcard__open'); if (o) o.setAttribute('aria-expanded', s.classList.contains('far-vf-is-open') ? 'true' : 'false'); }, 0); }

  /* prodotti dedicati della moto, con le etichette cb-tipo (una volta per sessione) */
  var dedCache = null;
  function dedicati() {
    var m = leggi();
    if (!m || !m.handles || !m.handles.length) return Promise.resolve([]);
    var handles = m.handles.slice(0, 40);
    var key = 'far:ded2:' + (m.t || '') + ':' + handles.length;
    if (dedCache && dedCache.key === key) return dedCache.p;
    var cached = null; try { cached = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (e) {}
    var p;
    if (cached) { p = Promise.resolve(cached); }
    else {
      p = Promise.all(handles.map(function (h) {
        return fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (res) {
        var out = [];
        for (var i = 0; i < res.length; i++) {
          var p = res[i]; if (!p) continue;
          var tipi = []; (p.tags || []).forEach(function (t) { t = String(t).toLowerCase(); if (t.indexOf('cb-tipo-') === 0) tipi.push(t.slice(8)); });
          var img = p.featured_image ? String(p.featured_image) : '';
          if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=400';
          out.push({ handle: p.handle, url: p.url, title: p.title, img: img, price: p.price, available: p.available !== false, tipi: tipi });
        }
        try { if (leggi()) sessionStorage.setItem(key, JSON.stringify(out)); } catch (e) {}
        return out;
      });
    }
    dedCache = { key: key, p: p };
    return p;
  }
  function money(cents) {
    var fmt = (window.FAR_MONEY_FORMAT || cfg.getAttribute('data-money') || '');
    var v = cents / 100, comma = fmt.indexOf('comma_separator') > -1 || !fmt, nodec = fmt.indexOf('no_decimals') > -1;
    var s = nodec ? String(Math.round(v)) : v.toFixed(2);
    if (comma) s = s.replace('.', ',');
    var out = fmt ? fmt.replace(/\{\{[^}]*\}\}/, s) : ('€' + s);
    return out === fmt ? ('€' + s) : out;
  }
  /* prodotti dedicati di una categoria: quelli con almeno un'etichetta cb-tipo della categoria */
  function dedicatiPer(handle) {
    var tipi = TIPI[handle] || [];
    return dedicati().then(function (list) { return list.filter(function (p) { return p.available && p.tipi.some(function (t) { return tipi.indexOf(t) > -1; }); }); });
  }
  window.FARMoto = { leggi: leggi, etichetta: etichetta, urlRisultati: urlRisultati, apri: apri, togli: togliMoto, dedicati: dedicati, dedicatiPer: dedicatiPer, tipi: TIPI, money: money, root: ROOT, T: T, foto: foto, piastrella: piastrella, disponi: function () { disponi(); } };

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function escA(s) { return esc(s).replace(/"/g, '&quot;'); }
  function evento(m, motivo) { try { document.dispatchEvent(new CustomEvent('far:moto-change', { detail: { moto: m, motivo: motivo } })); } catch (e) {} }

  /* foto del modello: feed della pagina marca, una volta per moto; foto di un'altra moto («rappresentativa») = simbolo.
     Il risultato si tiene anche in memoria della pagina: se il browser non riesce a salvarlo (memoria piena o navigazione privata) non si
     riscarica l'elenco della marca all'infinito (un tentativo per pagina). */
  function chiaveMoto(m) { return squash(m.marca) + '|' + squash(m.modello); }
  var fotoMem = {}, fotoInCorso = {};
  function fotoSalvata(m) {
    var k = chiaveMoto(m), f = null;
    try { f = JSON.parse(localStorage.getItem('far:moto-foto') || 'null'); } catch (e) {}
    if (f && f.k === k && f.t && Date.now() - f.t < 7 * 864e5) return f;
    return Object.prototype.hasOwnProperty.call(fotoMem, k) ? { k: k, u: fotoMem[k] } : null;
  }
  function caricaFoto(m) {
    var k = chiaveMoto(m), mod = squash(m.modello);
    if (fotoInCorso[k]) return fotoInCorso[k];
    var colls = (COLL[squash(m.marca)] || []).slice();
    /* «PIAGGIO · Vespa LX» nella tendina = «VESPA · LX» nelle pagine marca (stesso scooter, solo il nome scritto in due modi) */
    var chiavi = [k], modelli = [mod];
    if (squash(m.marca) === 'piaggio' && mod.indexOf('vespa') === 0 && mod.length > 5) { chiavi.push('vespa|' + mod.slice(5)); modelli.push(mod.slice(5)); }
    function salva(u) { fotoMem[k] = u; try { localStorage.setItem('far:moto-foto', JSON.stringify({ k: k, u: u, t: Date.now() })); } catch (e) {} }
    /* foto solo se è della moto vera: «rp» (foto rappresentativa di un'altra moto) vuoto, oppure con dentro il nome del modello */
    function cerca(items) {
      var trovata = false;
      for (var q = 0; q < chiavi.length; q++) {
        for (var i = 0; i < items.length; i++) {
          var x = items[i];
          if (squash(x.b) + '|' + squash(x.m) !== chiavi[q]) continue;
          trovata = true;
          if (x.i && (!x.rp || (modelli[q].length >= 3 && squash(x.rp).indexOf(modelli[q]) > -1))) return { trovata: true, u: String(x.i) };
        }
      }
      return { trovata: trovata, u: '' };
    }
    if (!colls.length) { salva(''); return Promise.resolve(''); }
    fotoInCorso[k] = new Promise(function (fine) {
      (function prossima() {
        var c = colls.shift();
        if (!c) { salva(''); delete fotoInCorso[k]; fine(''); pillola(); return; }
        fetch(ROOT + '/collections/' + c + '?view=far-modelli', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
          var esito = cerca((j && j.items) || []), u = esito.u;
          if (u) { u = u.replace(/([?&])width=\d+/, '$1width=160'); if (u.indexOf('width=') < 0) u += (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
          if (!esito.trovata && colls.length) { prossima(); return; }
          salva(u); delete fotoInCorso[k]; fine(u);
          var ora = leggi(); if (ora && chiaveMoto(ora) === k) pillola();
        }).catch(function () { fotoMem[k] = ''; delete fotoInCorso[k]; fine(''); });
      })();
    });
    return fotoInCorso[k];
  }
  /* FARMoto.foto(m) → Promise con l'indirizzo della foto ('' = simbolo) */
  function foto(m) {
    if (!m) return Promise.resolve('');
    var f = fotoSalvata(m);
    return f ? Promise.resolve(f.u || '') : caricaFoto(m);
  }
  function mediaInner(u) { return u ? '<img src="' + escA(u) + '" alt="" width="60" height="40" decoding="async">' : SYM; }
  function attivaFoto(el) {
    var imgs = el.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) (function (img) {
      if (img.getAttribute('data-far-g')) return;
      img.setAttribute('data-far-g', '1');
      function ok() { img.classList.add('is-ok'); }
      function ko() { var box = img.parentNode; if (!box) return; box.innerHTML = SYM; box.classList.add(box.classList.contains('far-vf-mobile-icon') ? 'far-g-sym' : 'far-garage__media--sym'); }
      if (img.complete && img.naturalWidth) ok(); else if (img.complete) ko(); else { img.addEventListener('load', ok); img.addEventListener('error', ko); }
    })(imgs[i]);
  }
  /* FARMoto.piastrella(m) → la stessa piastrella foto/simbolo del riquadro della barra, per le altre sezioni (fascia delle categorie);
     se la foto arriva dopo, la piastrella si aggiorna da sola */
  function piastrella(m) {
    var box = document.createElement('span');
    var f = m ? fotoSalvata(m) : null, u = f ? (f.u || '') : '';
    box.className = 'far-garage__media' + (u ? '' : ' far-garage__media--sym');
    box.setAttribute('aria-hidden', 'true');
    box.innerHTML = mediaInner(u);
    if (u) attivaFoto(box);
    else if (m && !f) foto(m).then(function (v) { if (!v) return; box.className = 'far-garage__media'; box.innerHTML = mediaInner(v); attivaFoto(box); });
    return box;
  }
  function garageHTML(m, u) {
    var stato = etichetta(m), cambiaMoto = T.cambiaMoto || T.cambia || '';
    /* scritta d'aiuto = nome intero (il nome lungo è tagliato con «…»; l'area di tocco :after copre tutto il collegamento, quindi la
       scritta è quella del collegamento); per i lettori di schermo nome e azione.
       Punto I: «Cambia» è un pulsante-icona (⇄) con scritta d'aiuto «Cambia moto»; la parola «Cambia» si vede solo quando il cruscotto è
       largo (tablet, cruscotto a tutta riga); niente più filo separatore (spazio risparmiato per il nome). */
    return '<span class="far-garage">' +
      '<a class="far-garage__main" href="' + escA(urlRisultati(m)) + '" title="' + escA(stato) + '" aria-label="' + escA((T.tua ? T.tua + ': ' : '') + stato + (T.vedi ? ' – ' + T.vedi : '')) + '">' +
        '<span class="far-garage__media' + (u ? '' : ' far-garage__media--sym') + '">' + mediaInner(u) + '</span>' +
        '<span class="far-garage__txt"><span class="far-garage__eyebrow">' + esc(T.tua) + '</span><span class="far-garage__name">' + esc(stato) + '</span></span>' +
      '</a>' +
      '<button type="button" class="far-garage__cambia" data-far-apri-moto aria-label="' + escA(cambiaMoto) + '" title="' + escA(cambiaMoto) + '">' + ICO_CAMBIA + '<span class="far-garage__cambia-txt">' + esc(T.cambia) + '</span></button>' +
      '<button type="button" class="far-garage__x" aria-label="' + escA(T.togli) + '" title="' + escA(T.togli) + '">' + ICO_X + '</button>' +
    '</span>';
  }

  /* PUNTO I · il cruscotto nella riga delle tendine (computer e tablet). La barra con la moto deve avere le stesse righe e la stessa
     altezza della barra senza moto (niente spazio in più, niente salto quando si toglie la moto). Come starebbe la barra senza moto lo dice
     la «sonda»: una copia invisibile della riga (stesse classi e stessi testi: etichetta originale, 4 tendine, CERCA, «Non trovi la tua
     moto?»), messa sotto la riga vera senza occupare spazio. Da 1024 px:
       m1  = la sonda sta su una riga → tutto su una riga: cruscotto, 4 tendine, CERCA, «Non trovi la tua moto?» su due righe strette;
       m2l = sotto va solo «Non trovi la tua moto?» → prima riga cruscotto + 4 tendine + CERCA, sotto il collegamento (come senza moto);
       m2b = sotto vanno CERCA e il collegamento → prima riga cruscotto + 4 tendine, sotto CERCA e il collegamento (come senza moto);
     tra 750 e 1023 px (e in ogni altro caso) m2f = due righe come senza moto (correzione del 21/10 sera): in alto cruscotto, marca e
     modello, sotto versione, anno, CERCA e «Non trovi la tua moto?». Altezza e angoli del cruscotto = quelli delle tendine.
     Sotto i 750 px la sonda si toglie (la pagina può diventare stretta: telefono girato, finestra ristretta). */
  var MODI = ['far-vf--m1', 'far-vf--m2l', 'far-vf--m2b', 'far-vf--m2f'];
  function largo(px) { return window.matchMedia ? window.matchMedia('(min-width:' + px + 'px)').matches : (window.innerWidth || 0) >= px; }
  function sonda(inn, lbl) {
    var x = inn.parentNode.querySelector('.far-vf__in--sonda');
    if (x) return x;
    x = document.createElement('div');
    x.className = 'far-vf__in far-vf__in--sonda';
    x.setAttribute('aria-hidden', 'true');
    var h = '<span class="far-vf__lbl">' + (lbl.getAttribute('data-far-orig') || '') + '</span>';
    var sels = inn.querySelectorAll('.far-vf__sel select');
    for (var i = 0; i < sels.length; i++) {
      var o = sels[i].options && sels[i].options[0];
      h += '<div class="far-vf__sel"><select tabindex="-1" disabled><option value="">' + esc(o ? o.text : '') + '</option></select></div>';
    }
    var b = inn.querySelector('.far-vf__btn'), n = inn.querySelector('.far-vf__nontrov');
    if (b) h += '<button type="button" class="far-vf__btn" tabindex="-1" disabled>' + esc(b.textContent.trim()) + '</button>';
    if (n) h += '<a class="far-vf__nontrov">' + esc(n.textContent.trim()) + '</a>';
    x.innerHTML = h;
    inn.parentNode.insertBefore(x, inn.nextSibling);
    return x;
  }
  /* righe della sonda: elementi con lo stesso centro verticale (la riga è centrata) = stessa riga */
  function righe(x) {
    var kids = x.children, gruppi = [];
    for (var i = 0; i < kids.length; i++) {
      var r = kids[i].getBoundingClientRect(); if (!r.width && !r.height) continue;
      var c = r.top + r.height / 2, g = null;
      for (var j = 0; j < gruppi.length; j++) if (Math.abs(gruppi[j].c - c) < 4) { g = gruppi[j]; break; }
      if (!g) { g = { c: c, el: [] }; gruppi.push(g); }
      g.el.push(kids[i]);
    }
    gruppi.sort(function (a, b) { return a.c - b.c; });
    return gruppi;
  }
  function solo(g, classi) {
    if (g.el.length !== classi.length) return false;
    for (var i = 0; i < classi.length; i++) if (!g.el[i].classList.contains(classi[i])) return false;
    return true;
  }
  var dispStato = '';
  function disponi() {
    var s = sez(); if (!s) return;
    var inn = s.querySelector('.far-vf__in'), lbl = inn && inn.querySelector('.far-vf__lbl');
    if (!inn || !lbl || inn.classList.contains('far-vf__in--sonda')) return;
    var attivo = !!(lbl.querySelector('.far-garage') || lbl.querySelector('.far-garage-msg')) && lbl.hasAttribute('data-far-orig') && largo(750);
    if (!attivo) {
      if (s.classList.contains('far-vf--cr')) { s.classList.remove('far-vf--cr'); for (var k = 0; k < MODI.length; k++) s.classList.remove(MODI[k]); inn.style.minHeight = ''; }
      /* correzione 21/10 sera: la sonda si toglie (pagina diventata stretta, telefono girato, moto tolta); se serve si rifà */
      var so = inn.parentNode.querySelector('.far-vf__in--sonda'); if (so) so.parentNode.removeChild(so);
      dispStato = '';
      return;
    }
    var x = sonda(inn, lbl);
    var g = righe(x), xr = x.getBoundingClientRect();
    if (!g.length || !xr.height) return; /* barra nascosta: si rifà al prossimo controllo */
    var modo = 'far-vf--m2f';
    if (largo(1024)) {
      if (g.length === 1) modo = 'far-vf--m1';
      else if (g.length === 2 && solo(g[1], ['far-vf__nontrov'])) modo = 'far-vf--m2l';
      else if (g.length === 2 && solo(g[1], ['far-vf__btn', 'far-vf__nontrov'])) modo = 'far-vf--m2b';
    }
    var sel = x.querySelector('.far-vf__sel'), sb = x.querySelector('select'), bt = x.querySelector('.far-vf__btn');
    var selH = sel ? Math.round(sel.getBoundingClientRect().height * 10) / 10 : 50;
    var btW = bt ? Math.round(bt.getBoundingClientRect().width * 10) / 10 : 102;
    var rad = '4px'; try { rad = getComputedStyle(sb).borderTopLeftRadius || rad; } catch (e) {}
    var h0 = Math.round(xr.height * 10) / 10;
    var nuovo = modo + '|' + h0 + '|' + selH + '|' + btW + '|' + rad;
    if (!(nuovo === dispStato && s.classList.contains('far-vf--cr'))) {
      dispStato = nuovo;
      for (var i = 0; i < MODI.length; i++) s.classList.toggle(MODI[i], MODI[i] === modo);
      s.classList.add('far-vf--cr');
      s.style.setProperty('--far-sel-h', selH + 'px');
      s.style.setProperty('--far-sel-r', rad);
      s.style.setProperty('--far-btn-w', btW + 'px');
      /* rete di sicurezza: mai più bassa della barra senza moto (niente salto quando la moto si toglie) */
      inn.style.minHeight = h0 + 'px';
    }
    stringi(s, inn, x, lbl, modo);
  }
  /* correzione 21/10 sera · nessuna scritta delle tendine tagliata per colpa del cruscotto: se una tendina (la sua scritta iniziale,
     es. «Selecciona el modelo») senza moto si legge intera e con il cruscotto no, il cruscotto si stringe quanto basta (mai sotto
     200 px; il nome lungo finisce con «…» e si legge intero passando il mouse). Larghezza nella variabile --far-cr-w (282 px di base). */
  var CR_MAX = 282, CR_MIN = 200, tela = null;
  function largTesto(el, t) {
    try {
      tela = tela || document.createElement('canvas').getContext('2d');
      var cs = getComputedStyle(el);
      tela.font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + cs.fontSize + ' ' + cs.fontFamily;
      return tela.measureText(t).width + (parseFloat(cs.letterSpacing) || 0) * t.length;
    } catch (e) { return 0; }
  }
  function spazio(el) { var cs = getComputedStyle(el); return el.clientWidth - (parseFloat(cs.paddingLeft) || 0) - (parseFloat(cs.paddingRight) || 0); }
  function manca(inn, x) {
    var a = inn.querySelectorAll('.far-vf__sel select'), b = x.querySelectorAll('.far-vf__sel select'), m = 0;
    for (var i = 0; i < a.length && i < b.length; i++) {
      var o = a[i].options && a[i].options[0]; if (!o || !a[i].clientWidth) continue;
      var tw = largTesto(a[i], o.text) + 2; /* 2 px di respiro */
      var qui = spazio(a[i]);
      if (tw > qui && tw <= spazio(b[i])) m = Math.max(m, tw - qui);
    }
    return m;
  }
  function stringi(s, inn, x, lbl, modo) {
    try {
      var prima = s.style.getPropertyValue('--far-cr-w');
      s.style.removeProperty('--far-cr-w'); /* si misura con il cruscotto pieno */
      var m = manca(inn, x), w = '';
      if (m > 0) {
        var k = modo === 'far-vf--m2f' ? 2 : 4; /* tendine sulla riga del cruscotto */
        w = Math.max(CR_MIN, Math.floor(Math.min(CR_MAX, lbl.getBoundingClientRect().width) - k * m)) + 'px';
      }
      if (w) s.style.setProperty('--far-cr-w', w);
      if (w !== prima) { s.classList.toggle('far-vf--stretto', !!w); disponiPresto(); } /* un controllo in più al fotogramma dopo */
    } catch (e) {} /* se qualcosa non va il cruscotto resta largo com'è: nient'altro si ferma */
  }
  var dispRaf = 0;
  function disponiPresto() { cancelAnimationFrame(dispRaf); dispRaf = requestAnimationFrame(disponi); }
  function bottoneX(cls) {
    var x = document.createElement('button');
    x.type = 'button'; x.className = 'far-garage__x ' + cls;
    x.setAttribute('aria-label', T.togli || ''); x.title = T.togli || '';
    x.innerHTML = ICO_X;
    return x;
  }
  /* X del telefono nella home: fratello della scheda nera, sopra la terza colonna (tra il nome e il «+") */
  function posX() {
    var s = sez(); if (!s) return;
    var x = s.querySelector('.far-garage__x--m'), t = s.querySelector('.far-vf-mobile-toggle'), p = t && t.querySelector('.far-vf-mobile-plus');
    if (!x || !t || !p || !t.offsetWidth || !p.offsetWidth) return;
    var rs = s.getBoundingClientRect(), rt = t.getBoundingClientRect(), rp = p.getBoundingClientRect();
    x.style.top = Math.round(rt.top - rs.top - s.clientTop + (rt.height - 44) / 2) + 'px';
    x.style.left = Math.round(rp.left - rs.left - s.clientLeft - 8 - 44) + 'px';
    x.style.right = 'auto';
  }
  /* home e carrello caricano più avanti far-vehicle-finder-pro.js, che crea la sua scheda nera: lì la scheda di qui non serve */
  function proInArrivo() { return !!document.querySelector('script[src*="far-vehicle-finder-pro"]') || (document.readyState === 'loading' && (TPL === 'index' || TPL === 'cart')); }
  function apertaAttr(s) { return s.classList.contains('far-vf-is-open') ? 'true' : 'false'; }
  /* scheda del telefono rimasta dopo la X (altre pagine): resta al suo posto (la pagina non salta) e apre la barra */
  function mcardVuota(card, s) {
    if (card.getAttribute('data-far-pill') === 'vuota') return;
    card.className = 'far-mcard far-mcard--vuota';
    card.innerHTML = '<button type="button" class="far-mcard__open" aria-expanded="' + apertaAttr(s) + '" aria-controls="FarVehicleFinder-ricerca-veicolo-far">' +
      '<span class="far-garage__media far-garage__media--sym">' + SYM + '</span>' +
      '<span class="far-mcard__txt"><span class="far-mcard__tit">' + esc(T.scegli) + '</span><span class="far-mcard__sub">' + esc(T.mma) + '</span></span>' +
      '<span class="far-mcard__plus" aria-hidden="true"></span></button>';
    card.setAttribute('data-far-pill', 'vuota');
  }

  /* 1) riquadro «La tua moto» nella barra */
  var apriDopo = false; try { apriDopo = sessionStorage.getItem('far:apri-dopo') === '1'; } catch (e) {}
  function pillola() {
    var s = sez(); if (!s) return;
    var m = leggi();
    var toggle = s.querySelector('.far-vf-mobile-toggle');
    var mt = toggle && toggle.querySelector('.far-vf-mobile-title'), ms = toggle && toggle.querySelector('.far-vf-mobile-subtitle');
    var icon = toggle && toggle.querySelector('.far-vf-mobile-icon'), lbl = s.querySelector('.far-vf__lbl');
    var stato = m ? etichetta(m) : '';
    var f = m ? fotoSalvata(m) : null, u = f ? (f.u || '') : '';
    if (m && !f) caricaFoto(m);
    var chiave = stato + '|' + u;
    var xm = s.querySelector('.far-garage__x--m'), card = s.querySelector('.far-mcard');
    if (m) {
      /* computer */
      if (lbl) {
        if (!lbl.hasAttribute('data-far-orig')) lbl.setAttribute('data-far-orig', lbl.innerHTML);
        if (lbl.getAttribute('data-far-pill') !== chiave || !lbl.querySelector('.far-garage')) { lbl.innerHTML = garageHTML(m, u); lbl.setAttribute('data-far-pill', chiave); attivaFoto(lbl); }
      }
      /* telefono, home */
      if (toggle) {
        if (mt) { if (!mt.hasAttribute('data-far-orig')) mt.setAttribute('data-far-orig', mt.textContent); if (mt.textContent !== T.tua) mt.textContent = T.tua; }
        if (ms && !ms.hasAttribute('data-far-orig')) ms.setAttribute('data-far-orig', ms.textContent);
        var nm = toggle.querySelector('.far-vf-mobile-moto');
        if (!nm && mt) { nm = document.createElement('span'); nm.className = 'far-vf-mobile-moto'; mt.parentNode.insertBefore(nm, mt.nextSibling); }
        if (nm && nm.textContent !== stato) nm.textContent = stato;
        if (icon) {
          if (!icon.hasAttribute('data-far-orig')) icon.setAttribute('data-far-orig', icon.innerHTML);
          if (icon.getAttribute('data-far-pill') !== chiave) { icon.innerHTML = mediaInner(u); icon.classList.toggle('far-g-sym', !u); icon.setAttribute('data-far-pill', chiave); attivaFoto(icon); }
        }
        if (!xm) xm = bottoneX('far-garage__x--m');
        if (xm.previousElementSibling !== toggle) toggle.insertAdjacentElement('afterend', xm);
        if (card) { card.parentNode.removeChild(card); card = null; }
      } else if (xm) { xm.parentNode.removeChild(xm); }
      /* telefono, altre pagine (non nella pagina risultati, che mostra già la moto nella sua fascia). La scheda si crea subito, mentre la
         pagina si sta ancora caricando, così non spinge giù la pagina già disegnata (CLS). Se far-vehicle-finder-pro.js arriva in
         un'altra pagina, la sua scheda prende il posto di questa (sopra, ramo «telefono, home»). */
      if (!toggle && !proInArrivo() && !suRisultati()) {
        if (!card) {
          card = document.createElement('div'); card.className = 'far-mcard';
          s.insertBefore(card, s.firstChild);
        }
        if (card.getAttribute('data-far-pill') !== chiave) {
          card.className = 'far-mcard';
          card.innerHTML = '<button type="button" class="far-mcard__open" aria-expanded="' + apertaAttr(s) + '" aria-controls="FarVehicleFinder-ricerca-veicolo-far">' +
            '<span class="far-garage__media' + (u ? '' : ' far-garage__media--sym') + '">' + mediaInner(u) + '</span>' +
            '<span class="far-mcard__txt"><span class="far-garage__eyebrow">' + esc(T.tua) + '</span><span class="far-garage__name">' + esc(stato) + '</span></span>' +
            '<span class="far-mcard__plus" aria-hidden="true"></span></button>';
          card.appendChild(bottoneX('far-garage__x--c'));
          card.setAttribute('data-far-pill', chiave); attivaFoto(card);
        }
      } else if (card && (toggle || suRisultati())) { card.parentNode.removeChild(card); }
      s.classList.add('far-vf--moto');
      posX();
    } else {
      if (mt && mt.hasAttribute('data-far-orig')) mt.textContent = mt.getAttribute('data-far-orig');
      if (ms && ms.hasAttribute('data-far-orig') && !ms.classList.contains('far-msg')) ms.textContent = ms.getAttribute('data-far-orig');
      var nm2 = toggle && toggle.querySelector('.far-vf-mobile-moto'); if (nm2) nm2.parentNode.removeChild(nm2);
      if (icon && icon.hasAttribute('data-far-orig')) { icon.innerHTML = icon.getAttribute('data-far-orig'); icon.classList.remove('far-g-sym'); icon.removeAttribute('data-far-pill'); }
      if (xm) xm.parentNode.removeChild(xm);
      /* telefono, altre pagine: dopo la X la scheda non sparisce (la pagina salterebbe su): resta vuota, con «Scegli la tua moto».
         Dopo la X nella scheda prodotto (pagina ricaricata) si crea subito vuota, per il messaggio. */
      if (!card && (tolta || apriDopo) && !toggle && !proInArrivo() && !suRisultati()) {
        card = document.createElement('div'); card.className = 'far-mcard far-mcard--vuota';
        s.insertBefore(card, s.firstChild);
      }
      if (card) { if (toggle || suRisultati()) card.parentNode.removeChild(card); else mcardVuota(card, s); }
      if (lbl && lbl.hasAttribute('data-far-orig') && lbl.hasAttribute('data-far-pill')) { lbl.innerHTML = lbl.getAttribute('data-far-orig'); lbl.removeAttribute('data-far-pill'); }
      s.classList.remove('far-vf--moto');
    }
    disponi();
    rigaMenu(m);
  }

  /* la X: via la moto dalla memoria, barra di nuovo vuota e aperta sulla marca */
  var tolta = 0, msgTimer = 0, annuncio = null;
  function azzeraTendine() {
    var b = document.getElementById(BRAND);
    if (b && b.value) { b.value = ''; try { b.dispatchEvent(new Event('change')); } catch (e) {} }
  }
  function annuncia(txt) {
    if (!annuncio) { annuncio = document.createElement('div'); annuncio.className = 'far-sr'; annuncio.setAttribute('role', 'status'); annuncio.setAttribute('aria-live', 'polite'); document.body.appendChild(annuncio); }
    annuncio.textContent = '';
    setTimeout(function () { annuncio.textContent = txt; }, 80);
  }
  /* «✓ Moto tolta: scegline un'altra» per 4 secondi: computer nel riquadro, telefono nel sottotitolo della scheda nera; poi il testo normale */
  function messaggio() {
    annuncia(T.tolta || '');
    var s = sez(); if (!s) return;
    clearTimeout(msgTimer);
    var lbl = s.querySelector('.far-vf__lbl');
    if (lbl) {
      /* dopo la X nella scheda prodotto la pagina si è ricaricata senza moto: l'etichetta non è mai stata cambiata, si salva qui il testo
         originale (così il messaggio si vede anche su computer e dopo 4 secondi torna «Ricerca per moto») */
      if (!lbl.hasAttribute('data-far-orig') && !lbl.querySelector('.far-garage')) lbl.setAttribute('data-far-orig', lbl.innerHTML);
      if (lbl.hasAttribute('data-far-orig')) lbl.innerHTML = '<span class="far-garage-msg" aria-hidden="true"><span class="far-garage-msg__ico">' + ICO_OK + '</span><span class="far-garage-msg__t">' + esc(T.tolta) + '</span></span>';
    }
    var sub = s.querySelector('.far-vf-mobile-toggle .far-vf-mobile-subtitle') || s.querySelector('.far-mcard--vuota .far-mcard__sub');
    if (sub) {
      if (!sub.classList.contains('far-msg')) sub.setAttribute('data-far-msg-prima', sub.textContent);
      sub.innerHTML = '<span class="far-msg__ok" aria-hidden="true">✓</span> ' + esc(T.tolta);
      sub.classList.add('far-msg');
    }
    s.classList.add('far-vf--msg'); /* anche su computer: se il cliente sceglie una marca il messaggio finisce subito */
    disponi(); /* punto I: il messaggio sta nel posto del cruscotto, la barra non cambia altezza */
    msgTimer = setTimeout(fineMessaggio, 4000);
  }
  function fineMessaggio() {
    clearTimeout(msgTimer);
    var s = sez(); if (!s) return;
    s.classList.remove('far-vf--msg');
    var lbl = s.querySelector('.far-vf__lbl');
    if (lbl && !leggi() && lbl.querySelector('.far-garage-msg') && lbl.hasAttribute('data-far-orig')) lbl.innerHTML = lbl.getAttribute('data-far-orig');
    disponi();
    var subs = s.querySelectorAll('.far-msg');
    for (var i = 0; i < subs.length; i++) {
      var sub = subs[i];
      /* se nel frattempo la scheda ha scritto la marca scelta, si lascia il suo testo */
      if (sub.querySelector('.far-msg__ok')) sub.textContent = sub.getAttribute('data-far-msg-prima') || '';
      sub.classList.remove('far-msg'); sub.removeAttribute('data-far-msg-prima');
    }
  }
  function togliMoto() {
    var ricarica = !!document.querySelector('[data-far-moto-monta]');
    try { localStorage.removeItem('far:moto'); localStorage.removeItem('far:attacco'); localStorage.removeItem('far:moto-foto'); } catch (e) {}
    try { for (var i = sessionStorage.length - 1; i >= 0; i--) { var k = sessionStorage.key(i); if (k && k.indexOf('far:ded2:') === 0) sessionStorage.removeItem(k); } } catch (e) {}
    dedCache = null; tolta = Date.now(); ultimoRaw = null;
    azzeraTendine();
    pillola();
    evento(null, 'tolta');
    if (ricarica) { try { sessionStorage.setItem('far:apri-dopo', '1'); } catch (e) {} location.reload(); return; }
    messaggio();
    apri();
  }
  /* pagina risultati: se la X arriva prima del catalogo o del filetto, la pagina riscriverebbe moto e filetto dall'indirizzo */
  function guardia() {
    if (!tolta || Date.now() - tolta > 20000 || !suRisultati()) return;
    var m = null, a = null;
    try { m = JSON.parse(rawMoto() || 'null'); } catch (e) {}
    try { a = JSON.parse(localStorage.getItem('far:attacco') || 'null'); } catch (e) {}
    if (a && (!a.t || a.t >= tolta)) { try { localStorage.removeItem('far:attacco'); } catch (e) {} }
    if (m && (!m.t || m.t >= tolta)) { try { localStorage.removeItem('far:moto'); } catch (e) {} ultimoRaw = null; dedCache = null; pillola(); }
  }
  document.addEventListener('far:fitment-ready', function () {
    setTimeout(pillola, 300);
    if (tolta && suRisultati() && Date.now() - tolta < 20000) setTimeout(function () { guardia(); azzeraTendine(); }, 80);
  });
  document.addEventListener('far:attacco', function () { if (tolta) setTimeout(guardia, 0); });

  /* 2) menu: foto piccole e prima riga della moto nelle tendine */
  function handleDa(href) { try { var p = new URL(href, location.origin).pathname.replace(/\/$/, ''); return p.split('/').pop(); } catch (e) { return ''; } }
  function fotoMenu() {
    var items = document.querySelectorAll('#shopify-section-horizontal-menu .submenu ul.dropdown li.level-1 > a:not(.far-menu-con-foto)');
    for (var i = 0; i < items.length; i++) {
      var a = items[i]; var h = handleDa(a.getAttribute('href') || '');
      var src = FOTO[h]; if (!src) continue;
      var img = document.createElement('img'); img.className = 'far-menu-img'; img.src = src; img.alt = ''; img.loading = 'lazy'; img.width = 34; img.height = 34;
      a.insertBefore(img, a.firstChild); a.classList.add('far-menu-con-foto');
    }
  }
  var tendine = ['specchietti-retrovisori', 'accessori-moto', 'componenti-moto'];
  function rigaMenu(m) {
    var parents = document.querySelectorAll('#shopify-section-horizontal-menu li.level0.bls__menu-parent');
    for (var i = 0; i < parents.length; i++) {
      var li = parents[i]; var a0 = li.querySelector(':scope > a'); if (!a0) continue;
      if (tendine.indexOf(handleDa(a0.getAttribute('href') || '')) < 0) continue;
      var ul = li.querySelector('.submenu ul.dropdown'); if (!ul) continue;
      var riga = ul.querySelector('li.far-menu-moto');
      if (!riga) {
        riga = document.createElement('li'); riga.className = 'relative level-1 far-menu-moto';
        var a = document.createElement('a'); a.className = 'site-nav level-1'; a.innerHTML = '<span class="far-pill-ico" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M5 11a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm14 0a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM5 13a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm14 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM8.5 6h3.2l1.6 2H16l1.2 2.6-1.8.8L14.6 10h-4.9L9 8H7.1zm2.2 4h2.6l1.5 3.2 1.4-.9 1 1.8-2.9 1.9L12.2 12H9.4l-1.7 3H5.6z"/></svg></span><span class="far-menu-moto-txt"></span>';
        riga.appendChild(a); ul.insertBefore(riga, ul.firstChild);
      }
      var link = riga.querySelector('a'), txt = riga.querySelector('.far-menu-moto-txt');
      if (m) { txt.textContent = (T.mostra || '{moto}').replace('{moto}', etichetta(m)); link.setAttribute('href', urlRisultati(m)); link.removeAttribute('data-far-apri-moto'); }
      else { txt.textContent = T.scegli || ''; link.setAttribute('href', MARCA); link.setAttribute('data-far-apri-moto', ''); }
    }
  }

  /* avvio e controlli */
  leggi(); /* una moto più vecchia di 90 giorni si toglie subito, prima che le sezioni della pagina la leggano */
  var ultimoRaw = rawMoto();
  function controlla() {
    var raw = rawMoto();
    if (raw !== ultimoRaw) { ultimoRaw = raw; dedCache = null; pillola(); evento(leggi(), raw ? 'cambiata' : 'tolta'); return true; }
    return false;
  }
  function serveRifare() {
    var s = sez(); if (!s || !leggi()) return false;
    var lbl = s.querySelector('.far-vf__lbl'), t = s.querySelector('.far-vf-mobile-toggle');
    if (lbl && !lbl.querySelector('.far-garage')) return true;
    if (t && (!t.querySelector('.far-vf-mobile-moto') || !s.querySelector('.far-garage__x--m'))) return true;
    return false;
  }
  function avvia() { fotoMenu(); pillola(); }
  avvia();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', avvia);
  setTimeout(avvia, 1500);
  window.addEventListener('load', function () { posX(); disponi(); });
  var rz = 0; window.addEventListener('resize', function () { cancelAnimationFrame(rz); rz = requestAnimationFrame(function () { posX(); disponi(); }); });
  /* i caratteri del tema cambiano la larghezza dei testi: quando sono pronti si rimisura la riga */
  try { if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { disponi(); }); } catch (e) {}
  window.addEventListener('storage', function (e) { if (!e.key || e.key === 'far:moto') controlla(); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { if (!controlla() && serveRifare()) pillola(); } });
  (function () {
    var s = sez(); if (!s) return;
    /* il cliente sceglie una marca mentre c'è il messaggio: il messaggio finisce subito */
    s.addEventListener('change', function () { if (s.classList.contains('far-vf--msg')) setTimeout(fineMessaggio, 0); });
    /* la scheda nera della home la (ri)crea far-vehicle-finder-pro.js: si rimettono foto, nome e X appena compare */
    if (!window.MutationObserver) return;
    var giro = 0;
    new MutationObserver(function (list) {
      var nostri = list.every(function (r) {
        return [].slice.call(r.addedNodes).concat([].slice.call(r.removedNodes)).every(function (n) { return n.nodeType !== 1 || (n.classList && (n.classList.contains('far-mcard') || n.classList.contains('far-garage__x--m'))); });
      });
      if (nostri) return;
      cancelAnimationFrame(giro); giro = requestAnimationFrame(pillola);
    }).observe(s, { childList: true });
    if (window.ResizeObserver) { var ro = new ResizeObserver(function () { posX(); disponiPresto(); }); ro.observe(s); }
  })();
  setInterval(function () {
    guardia();
    if (!controlla() && serveRifare()) pillola();
  }, 2000);
  /* dopo la X nella scheda prodotto la pagina si ricarica: si apre la barra e si mostra il messaggio */
  if (apriDopo) {
    try { sessionStorage.removeItem('far:apri-dopo'); } catch (e) {}
    setTimeout(function () { messaggio(); apri(); }, 500);
  }
})();

/* --- EFFETTO LUCE (22/10/2026): un solo ascoltatore delegato che accende l'impulso alla pressione (classe far-luce-imp,
   animazione in assets/far-moto.css) e lo spegne a fine animazione. Non ferma e non ritarda nulla: la classe si aggiunge
   alla pressione (pointerdown) e l'azione del pulsante (per esempio la X che toglie la moto) parte come prima.
   Per un pulsante nuovo: aggiungere il selettore a IMP (o a MINI per le pillole piccole dei filtri).
   Skill: .claude/skills/far-effetto-luce/SKILL.md · diario: FAR-programma/tema/effetto-luce-2026-10-22/LEGGIMI.md */
(function () {
  if (window.farLucePronto) return; window.farLucePronto = true;
  var MINI = '.far-gs__sti,.far-fl__op,.far-fl__chip,.far-gs__gp-chip';
  var IMP = '.far-garage__x,.far-garage__cambia,.far-vf-mobile-plus,.far-mcard__plus,.far-vf__btn,.far-gs__tab,.far-gs__hero-fil,.far-gs__more,.far-gs__supr-i,.far-gs__acc-freccia,.fnc__nav,.fsc__nav,.fsc__tab,' + MINI;
  function impulso(t) {
    if (!t || t.nodeType !== 1 || !t.closest) return;
    var el = null; try { el = t.closest(IMP); } catch (e) {}
    if (!el || el.disabled) return;
    el.classList.remove('far-luce-imp', 'far-luce-imp--mini');
    void el.offsetWidth; /* così l'anello riparte anche premendo due volte di fila */
    el.classList.add('far-luce-imp');
    var mini = false; try { mini = el.matches(MINI); } catch (e) {}
    if (mini) el.classList.add('far-luce-imp--mini');
    clearTimeout(el._farLuceT);
    el._farLuceT = setTimeout(function () { el.classList.remove('far-luce-imp', 'far-luce-imp--mini'); }, 800); /* rete di sicurezza (con reduced-motion non arriva nessun animationend) */
  }
  document.addEventListener('pointerdown', function (e) { if (e.button === 0) impulso(e.target); }, true);
  document.addEventListener('click', function (e) { if (e.detail === 0) impulso(e.target); }, true); /* Invio e Spazio da tastiera */
  document.addEventListener('animationend', function (e) {
    if (e.animationName !== 'farLuceImp' && e.animationName !== 'farLuceImpMini') return;
    var el = e.target;
    if (el && el.classList && el.classList.contains('far-luce-imp')) { el.classList.remove('far-luce-imp', 'far-luce-imp--mini'); clearTimeout(el._farLuceT); }
  }, true);
})();

/* --- EFFETTO LUCE · ESTENSIONE (22/10/2026 mattina, Diego dopo la demo: «usalo nel sito nei punti dove fa più effetto»).
   Secondo ascoltatore delegato, stesso principio del primo (qui sopra): alla pressione aggiunge la classe dell'impulso e non
   ferma né ritarda nulla (il clic di «Aggiungi al carrello», «Vai alla cassa» ecc. parte come prima). Liste:
   IMP   = anello sull'ombra del pulsante (farLuceImp);            OMBRA = come IMP ma conserva l'ombra di riposo delle frecce;
   PS    = anello nel ::after (Aggiungi al carrello: ombra !important nel tema);
   ICO   = cerchio di luce per le icone senza fondo (intestazione, menu del telefono);
   MINI  = anello corto e tenue;  QTY = i pulsanti +/− accendono il riquadro della quantità (anello corto).
   Animazioni in assets/far-moto.css (blocco «ESTENSIONE»). Skill: .claude/skills/far-effetto-luce/SKILL.md */
(function () {
  if (window.farLuceEstPronto) return; window.farLuceEstPronto = true;
  var IMP = '.bls-btn-checkout,.fgem__btn,.far-gs__chat,.swiper-button-next,.swiper-button-prev';
  var OMBRA = '.fxc-arrow,.fxs-arrow';
  var PS = '.product-form__submit';
  var ICO = '.top-search-toggle,.header__icon--account,#cart-icon-bubble,.nav-toggle,.close-menu';
  var MINI = '.is-nav-tabs,.btn-filter';
  var QTY = '.quantity__button';
  var TUTTI = [PS, IMP, OMBRA, ICO, MINI].join(',');
  var CLASSI = ['far-luce-imp', 'far-luce-imp--mini', 'far-luce-imp--ombra', 'far-luce-imp--ps', 'far-luce-imp--ico'];
  function togli(el) { for (var i = 0; i < CLASSI.length; i += 1) el.classList.remove(CLASSI[i]); }
  function combacia(el, s) { try { return el.matches(s); } catch (x) { return false; } }
  function impulso(t) {
    if (!t || t.nodeType !== 1 || !t.closest) return;
    var el = null, tipo = null;
    try {
      var q = t.closest(QTY);
      if (q) { if (q.disabled) return; el = q.closest('quantity-input,.quantity'); tipo = 'far-luce-imp--mini'; }
      else el = t.closest(TUTTI);
    } catch (x) { return; }
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true' || el.classList.contains('swiper-button-disabled')) return;
    if (!tipo) tipo = combacia(el, PS) ? 'far-luce-imp--ps' : combacia(el, ICO) ? 'far-luce-imp--ico' : combacia(el, OMBRA) ? 'far-luce-imp--ombra' : combacia(el, MINI) ? 'far-luce-imp--mini' : null;
    togli(el);
    void el.offsetWidth; /* così l'anello riparte anche premendo due volte di fila */
    el.classList.add('far-luce-imp');
    if (tipo) el.classList.add(tipo);
    clearTimeout(el._farLuceEstT);
    el._farLuceEstT = setTimeout(function () { togli(el); el._farLuceEstT = null; }, 900); /* rete di sicurezza (riduci movimento: nessun animationend) */
  }
  document.addEventListener('pointerdown', function (ev) { if (ev.button === 0) impulso(ev.target); }, true);
  document.addEventListener('click', function (ev) { if (ev.detail === 0) impulso(ev.target); }, true); /* Invio e Spazio da tastiera */
  document.addEventListener('animationend', function (ev) {
    var n = ev.animationName;
    if (n !== 'farLuceImp' && n !== 'farLuceImpMini' && n !== 'farLuceImpOmbra' && n !== 'farLuceImpIco') return;
    var el = ev.target;
    if (el && el._farLuceEstT) { clearTimeout(el._farLuceEstT); el._farLuceEstT = null; togli(el); }
  }, true);
})();
